import React, { createContext, useContext, useState } from 'react';

const ImageToolsOverlayContext = createContext();

export const useImageToolsOverlay = () => {
  const context = useContext(ImageToolsOverlayContext);
  if (!context) {
    throw new Error('useImageToolsOverlay must be used within ImageToolsOverlayProvider');
  }
  return context;
};

export const ImageToolsOverlayProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [collectionId, setCollectionId] = useState(null);
  const [prefilledData, setPrefilledData] = useState(null);
  const [activeTab, setActiveTab] = useState('stamp'); // Which tool to open

  const openOverlay = (options = {}) => {
    if (options.collectionId) setCollectionId(options.collectionId);
    if (options.prefilledData) setPrefilledData(options.prefilledData);
    if (options.activeTab) setActiveTab(options.activeTab);
    setIsOpen(true);
    setIsMinimized(options.minimized || false);
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setIsMinimized(false);
    // Clear prefilled data after a delay to avoid UI flash
    setTimeout(() => {
      setPrefilledData(null);
    }, 300);
  };

  const toggleMinimized = () => {
    setIsMinimized(!isMinimized);
  };

  const value = {
    isOpen,
    isMinimized,
    collectionId,
    prefilledData,
    activeTab,
    openOverlay,
    closeOverlay,
    toggleMinimized,
    setActiveTab,
  };

  return (
    <ImageToolsOverlayContext.Provider value={value}>
      {children}
    </ImageToolsOverlayContext.Provider>
  );
};
